import React, { Component } from 'react';
import {
	Link
} from 'react-router-dom';
import Preloader from '../img/preloader.gif';
import Api from '../config/Api';
import EachFileEgfr from './EachFileEgfr';

class Egfr extends Component {
	constructor(props) {
		super(props);
		this.state = {
			list: {},
			message: '',
			total: 0,
			token: (localStorage.token ? localStorage.token : sessionStorage.token),
			ready: false
		}
	}

	componentWillMount() {
		this.getFiles();
	}

	getFiles = () => {
		var self = this;
		Api.getEgfrFiles(JSON.stringify({ token: this.state.token }), function(response) {
			self.setState({
				list: response.list,
				total: response.total_results,
				message: response.message,
				ready: true
			});
		});
	}

	eachEntry = (res, i) => {
		return(
			<div key={i}>
				{i === 0 ?
					<div className="row titleRow mobileHide">
						<div style={{width: '20%', float: 'left'}}>Upload Date</div>
						<div style={{width: '25%', float: 'left'}}>File Name</div>
						<div style={{width: '15%', float: 'left'}}>File Type</div>
						<div style={{width: '15%', float: 'left'}}>Is eGFR Calculated</div>
						<div style={{width: '25%', float: 'left'}}>Actions</div>
					</div> :
					null
				}
				<EachFileEgfr key={i} index={i}>
					{res}
				</EachFileEgfr>
			</div>
		);
	}

    render() {
    	return(
    		<div className="blockCtr patients br10 sh1">
    			<div className="blockHeader br10Top">
    				<Link to="/" className="backBtn br10TopLeft"><span className="fas fa-chevron-left"></span></Link>
    				<h3>eGFR Calculation</h3>
    			</div>
    			<div className="blockInfo">
    				{this.state.ready ? (this.state.total === 0 ? 'No files available for calculation.' : null) : null}
					<div className="table">
						{this.state.ready ? this.state.list.map(this.eachEntry) : <img src={Preloader} alt="Fresenius Preloader" className="preloader" style={{display: 'block', maxHeight: 'auto'}} />}
					</div>
    			</div>
    		</div>
    	);
    }
}

export default Egfr;


// WEBPACK FOOTER //
// ./src/components/Egfr.js